import React from "react";
import PropTypes from "prop-types";
import { DayPickerCalendar } from "./day_picker_calendar";

const QuickDatePicker = ({ footer, onDayClick }) => {
  return (
    <div>
      <DayPickerCalendar
        enableOutsideDaysClick
        fixedWeeks
        footer={footer}
        mode="single"
        onDayClick={(date) => onDayClick(date)}
        showOutsideDays
        navLayout="around"
      />
    </div>
  );
}

export default QuickDatePicker;

QuickDatePicker.propTypes = {
  footer: PropTypes.string,
  onDayClick: PropTypes.func
};
